import { Component } from '@angular/core';
import { AppTabNavigationHeaderComponent } from '../../../components/navigation-header/app-navigation-header.component';
import { MatTabGroup, MatTab, MatTabContent } from '@angular/material/tabs';
import { QueryStringTabGroupDirective } from '../../../directives/query-string-tab-group.directive';
import { MyListComponent } from './my-list/my-list.component';
import { BreadcrumbLabelDirective } from '../../../directives/breadcrumb-label.directive';
import { PublicDirectoryComponent } from './public-directory/public-directory.component';

@Component({
	selector: 'app-companies-main-tab',
	templateUrl: './companies-main-tab.component.html',
	styleUrls: ['./companies-main-tab.component.css'],
	imports: [
		AppTabNavigationHeaderComponent,
		MatTabGroup,
		QueryStringTabGroupDirective,
		MatTab,
		MatTabContent,
		MyListComponent,
		BreadcrumbLabelDirective,
		PublicDirectoryComponent,
	],
})
export class CompaniesMainTabComponent {
	breadcrumbLabel = $localize`:@@companiesMain-breadcrumbLabel:Companies`;

	myListBreadcrumbLabel = this.breadcrumbLabel;
	publicDirectoryBreadcrumbLabel = this.breadcrumbLabel;

	constructor() {}
}
